import { render, staticRenderFns } from "./frameWorkWidge.vue?vue&type=template&id=e36dd7bc&scoped=true"
import script from "./frameWorkWidge.vue?vue&type=script&lang=js"
export * from "./frameWorkWidge.vue?vue&type=script&lang=js"
import style0 from "./frameWorkWidge.vue?vue&type=style&index=0&id=e36dd7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36dd7bc",
  null
  
)

export default component.exports